import { useCallback, useEffect, useRef } from 'react';

export const useDeferredFocus = (ref, delay = 50) => {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      clearTimeout(timerRef.current);
    },
    [],
  );

  return useCallback(() => {
    timerRef.current = setTimeout(() => ref.current?.focus(), delay);
  }, [delay, ref]);
};
